import React from 'react';

import { OppurtunityCard } from './OpportunityCard';
import { CrmHomeSection } from '../../../CrmHomeSection/CrmHomeSection';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Row, Col, Carousel } from 'wix-style-react';
import { CardDealerOffer } from '../../../../types';
import { CrmHomeBiLogger } from '../../../../bi-logger';

export interface OppurtinitySectionProps extends InjectedTranslateProps {
  biLogger: CrmHomeBiLogger;
  opportunities: CardDealerOffer[];
  onOpportunityActionClick(config): void;
}

export const OpportunitySectionComponent: React.FC<OppurtinitySectionProps> = (
  props,
) => {
  const { t, biLogger, opportunities } = props;
  const unrefedOpportunities = [...opportunities];
  const firstRow = unrefedOpportunities.slice(0, 3);
  const secondRow = unrefedOpportunities.slice(3, 6);

  const renderOpportunitiesRow = (rowData: CardDealerOffer[]) => {
    return (
      <Row stretchViewsVertically>
        {rowData.map((opportunity) => {
          return (
            <Col span={4} key={opportunity.title}>
              <OppurtunityCard
                title={t(opportunity.title)}
                subtitle={t(opportunity.body)}
                imageUrl={opportunity.illustration}
                mainActionText={t(opportunity.mainButtonText)}
                onMainActionClick={() => {
                  biLogger.reportCardButtonClicked(
                    'section-tool-cards',
                    opportunity.offerName,
                  );
                  props.onOpportunityActionClick(opportunity.mainButtonConfig);
                }}
                secondaryActionText={
                  opportunity.secondaryButtonText &&
                  t(opportunity.secondaryButtonText)
                }
                onSecondaryActionClick={() => {
                  biLogger.reportCardSecondaryButtonClicked(
                    opportunity.offerName,
                  );
                  props.onOpportunityActionClick(
                    opportunity.secondaryButtonConfig,
                  );
                }}
              />
            </Col>
          );
        })}
      </Row>
    );
  };
  return (
    <CrmHomeSection
      title={t('crmHomePage.opportunities.title')}
      titleDataHook={'opportunities'}
    >
      <Carousel
        buttonSkin="inverted"
        infinite
        beforeChange={() => {
          biLogger.reportCarouselClick();
        }}
      >
        {renderOpportunitiesRow(firstRow)}
        {secondRow.length && renderOpportunitiesRow(secondRow)}
      </Carousel>
    </CrmHomeSection>
  );
};

export const OpportunitySection = translate()(OpportunitySectionComponent);
